// Add keyframe animation to the document
const styleSheet = document.createElement('style')
styleSheet.textContent = `
	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
`
document.head.appendChild(styleSheet)

export const theme = {
	colors: {
		primary: '#0066FF',
		secondary: '#6B7280',
		surface: '#FFFFFF',
		background: '#F3F4F6',
		border: '#E5E7EB',
		text: {
			primary: '#111827',
			secondary: '#6B7280',
			muted: '#9CA3AF',
		},
		error: '#DC2626',
		success: '#059669',
	},
	borderRadius: {
		sm: '4px',
		md: '6px',
		lg: '8px',
		full: '9999px',
	},
	spacing: {
		xs: '4px',
		sm: '8px',
		md: '16px',
		lg: '24px',
		xl: '32px',
	},
	shadows: {
		sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
		md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
		lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
	},
	typography: {
		fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
		sizes: {
			tiny: '12px',
			sm: '14px',
			md: '16px',
			lg: '18px',
		},
		weights: {
			normal: 400,
			medium: 500,
			bold: 600,
		},
		lineHeight: {
			none: 1,
			tight: 1.25,
			snug: 1.375,
			normal: 1.5,
			relaxed: 1.625,
			loose: 2,
			compact: 1.35,
		},
	},
	zIndex: {
		base: 1,
		overlay: 10,
		modal: 100,
		tooltip: 1000,
	},
	transform: {
		scale: {
			default: 'scale(1)',
			hover: 'scale(1.05)',
			active: 'scale(0.95)',
		},
	},
} as const

export type Theme = typeof theme
